<template>
  <div>
    <div slot="title">
      <h2>Nueva Estructura Orgánica</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="form-group col-3">
            <label>Área</label>
            <C001Area
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Todas"
              v-on:valorParaElPadre="cambioArea"
              :parametros="parametros_Area"
            ></C001Area>
          </div>
          <div class="form-group col-3">
            <label for="departamentoId">Departamento</label>
            <C039TiposDepartamento
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              v-on:valorParaElPadre="CambioTipoDepartamento"
              :valorDefinido="parametros_Departamento.departamentoId"
              :hereda="this.parametros_Area.areaId"
              :key="this.parametros_Area.areaId"
            ></C039TiposDepartamento>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="tipoPuestoId">Puesto</label>
            <!-- Se comenta el componente de puestos para usar el componente de puestos con buscador -->
            <!-- <C045Puestos
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              v-on:valorParaElPadre="CambioTipoPuesto"
              :parametros="{}"
            ></C045Puestos>             -->
            <C045PuestosBuscador
              v-on:valorParaElPadre="CambioPuestoBuscador"
              :placeholder="'Seleccione un puesto'"
              :parametros="{}"
            >
            </C045PuestosBuscador>
          </div>

          <div class="form-group col-3">
            <label for="">* en caso de que no exista</label>
            <input
              v-model="nombreDeNuevoPuesto"
              class="form-control"
              placeholder="Introducir nuevo puesto*"
              type="text"
            />
          </div>
          <div v-if="nombreDeNuevoPuesto != ''" class="form-group col-3">
            <label            
              for="inputMuestraFirmaAutografa"
              >Muestra firma autógrafa </label
            >
            <input
              v-model="mostrarFirmaAutografa"
              type="checkbox"            
              id="inputMuestraFirmaAutografa"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            
          </div>
        </div>
        <div class="row">
          <div class="form-group col-3">
            <label>Tipos Puesto</label>
            <C044TiposPuestos
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              v-on:valorParaElPadre="CambioTipoPuesto"
            >
            </C044TiposPuestos>
          </div>
          <div class="form-group col-3">
            <label>Niveles de Puesto</label>
            <C052NivelesPuestos
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              v-on:valorParaElPadre="CambioNivelPuesto"
            >
            </C052NivelesPuestos>
          </div>
          <div class="form-group col-3">
            <label for>Fecha Inicial</label>
            <input
              v-model="fechaInicialDelPuesto"
              name="fechaInicialPeriodoLaboral"
              type="date"
              class="form-control"
            />
          </div>
          <div class="form-group col-3">
            <label for>Fecha Final</label>
            <input
              v-model="fechaFinalDelPuesto"
              name="fechaFinalPeriodoLaboral"
              type="date"
              class="form-control"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-3">
            <label>Turno</label>
            <C003TipoTurno
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              v-on:valorParaElPadre="CambioTipoTurno"
            >
            </C003TipoTurno>
          </div>
          <div class="form-group col-3">
            <label>Plaza</label>
            <C028TipoPlaza
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              v-on:valorParaElPadre="CambioTipoPlaza"
            >
            </C028TipoPlaza>
          </div>
          <div class="form-group col-3">
            <label>Categoría </label>
            <C060TiposCategoriasPuestos
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
            >
            </C060TiposCategoriasPuestos>
          </div>          
        </div>
        <hr />
        <div class="row">
          <div class="form-group col-3">
            <label for="">Buscar superior</label>
            <input
              v-model="nombreDePersonaABuscar"
              class="form-control"
              placeholder="Buscar superior"
              type="text"
            />
          </div>
          <div class="form-group d-flex align-items-end col-3">
            <button
              v-on:click="BuscarPersonaYSuEstructuraOrganica"
              class="btn btn-primary"
            >
              Buscar
            </button>
            <!-- :disabled="this.ValidarCURP(0)" -->
          </div>
        </div>
        <div class="row">
          <div class="col-12 table-responsive">
            <table
              class="table  table-striped table-light table-hover"
              id="tabla_PersonasParaElegirEstructuraOrganica"
              data-toggle="table"
              data-pagination="true"
              data-page-size="5"
              data-search="true"
              data-single-select="true"
              data-click-to-select="true"
            >
              <thead class="thead-dark">
                <tr>
                  <th data-checkbox="true"></th>
                  <th data-field="PersonaId" data-sortable="true">
                    Persona Id
                  </th>
                  <th data-field="Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th data-field="ApellidoPaterno" data-sortable="true">
                    Apellido Paterno
                  </th>
                  <th data-field="ApellidoMaterno" data-sortable="true">
                    Apellido Materno
                  </th>
                  <th
                    data-field="EstructuraOrganica.EstructuraOrganicaId"
                    data-sortable="true"
                  >
                    Estructura Organica Id
                  </th>
                  <!-- <th                       
                    data-events="operateEvents"                 
                    :data-formatter="this.operateFormatter()"
                  >
                    Acciones
                  </th> -->
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="form-group col-12 text-right">
            <button v-on:click="GuardarPuesto" class="btn btn-primary">
              Guardar
            </button>
            <!-- :disabled="this.ValidarCURP(0)" -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";

export default {
  data() {
    return {
      enumeraciones,
      fechaInicialDelPuesto: null,
      fechaFinalDelPuesto: null,
      nombreDePersonaABuscar: null,
      nombreDeNuevoPuesto: "",
      personasEncontradas: [],
      parametros_Area: {
        areaId: null
      },
      parametros_Departamento: {
        departamentoId: null
      },
      parametros_Puesto: {
        puestoId: null
      },
      parametros_TipoTurno:{
        tipoTurnoId: null
      },
      parametros_TipoPlaza:{
        tipoPlazaId: null
      },
      parametros_TipoPuesto:{
        tipoPuestoId:null
      },
      parametros_NivelPuesto:{
        nivelPuestoId:null
      },
      mostrarFirmaAutografa: false      
    };
  },
  components: {
    C001Area: catalogos.PJ.C001Area,
    C039TiposDepartamento: catalogos.PJ.C039TipoDepartamento,
    C045Puestos: catalogos.PJ.C045Puestos,
    C045PuestosBuscador: catalogos.PJ.C045PuestosBuscador,
    C044TiposPuestos: catalogos.PJ.C044TiposPuestos,
    C052NivelesPuestos: catalogos.PJ.C052NivelesPuestos,
    C003TipoTurno: catalogos.SIAP.C003TipoTurno,
    C028TipoPlaza: catalogos.SIAP.C028TipoPlaza,
    C060TiposCategoriasPuestos: catalogos.PJ.C060TiposCategoriasPuestos
  },
  methods: {
    cambioArea(datos) {
      this.parametros_Area.areaId = parseInt(datos.target.value);
      this.parametros_Departamento.departamentoId = -1;
      this.parametros_Puesto.puestoId = -1;
    },
    CambioTipoDepartamento(datos) {
      this.parametros_Departamento.departamentoId = parseInt(
        datos.target.value
      );
      this.parametros_Puesto.puestoId = -1;
    },
    CambioPuestoBuscador(datos){
      this.parametros_Puesto.puestoId = parseInt(datos.PuestoId); // se obtiene el valor de ésta forma ya que el valor viene del componente de puestos con buscador
      //this.parametros_TipoPuesto.tipoPuestoId = parseInt(datos.PuestoId); 
    },  
    CambioTipoPuesto(datos) {
      this.parametros_TipoPuesto.tipoPuestoId = parseInt(datos.target.value);
    },
    CambioNivelPuesto(datos){
      this.parametros_NivelPuesto.nivelPuestoId = parseInt(datos.target.value);
    },
    CambioTipoTurno(datos){      
      this.parametros_TipoTurno.tipoTurnoId = parseInt(datos.valor);
    },
    CambioTipoPlaza(datos){
      this.parametros_TipoPlaza.tipoPlazaId = parseInt(datos.valor);
    },
    //  SE COMENTA PORQUE SE DEJÓ DE USAR EL COMBO TRADICIONAL DE TIPO PUESTO POR EL QUE TIENE EL BUSCADOR 
    // CambioTipoPuesto(datos){
    //   this.parametros_TipoPuesto.tipoPuestoId = parseInt(datos.target.value);
    // },
    
    
    
    BuscarPersonaYSuEstructuraOrganica() {
      comun.SeEstaCargandoInformacion(true);

      var peticion = {
        esPrueba: false,
        nombreBusqueda: this.nombreDePersonaABuscar,
        numeroNominaBusqueda: parseInt(this.numeroNominaBusqueda, 10),
        tipoPuestoBusqueda: -1,
        interinoBusqueda: -1,
        deBaseBusqueda: -1,
        baneados: [],
        verInactivos: false,
        AreaId: -1,
        CargarEstructuraOrganica: true
      };

      axios
        .post(
          api.conexion + api.SIAP.funcion.GetPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            this.personasEncontradas = response.data.InfoPersonas;
            this.LlenarTablaDePersonasEncontradas();
          } else {
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error(e);
        });
    },

    GuardarPuesto() {
      //OBTIENE LA PERSONA QUE SE ELIGIÓ EN LA TABLA DE SUPERIORES 
      var $tabla_Personas = $("#tabla_PersonasParaElegirEstructuraOrganica");
      var personaElegidaComoSuperior = $tabla_Personas.bootstrapTable(
        "getSelections"
      );
      personaElegidaComoSuperior = (personaElegidaComoSuperior.length == 0)?null:personaElegidaComoSuperior[0].EstructuraOrganica.EstructuraOrganicaId;

      // SE MUESTRA EL MODAL DE CARGANDO INFORMACIÓN
      comun.SeEstaCargandoInformacion(true);

      // SE CREA ESTRUCTURA Y VALORES DE LA PETICIÓN
      var peticion = {
        AreaID: this.parametros_Area.areaId,
        DepartamentoID: this.parametros_Departamento.departamentoId,
        PuestoID: this.parametros_Puesto.puestoId,
        NombreDeNuevoPuesto: this.nombreDeNuevoPuesto,
        TipoDePuestoId: this.parametros_TipoPuesto.tipoPuestoId,
        NivelPuestoId: this.parametros_NivelPuesto.nivelPuestoId,
        FechaInicialDelPuesto: this.fechaInicialDelPuesto,
        FechaFinalDelPuesto: this.fechaFinalDelPuesto,        
        TurnoID: this.parametros_TipoTurno.tipoTurnoId,
        Tipo_PlazaID: this.parametros_TipoPlaza.tipoPlazaId,
        EstructuraOrganicaSuperiorId: personaElegidaComoSuperior,
        Activo: true,
        MostrarFirmaAutografa: this.mostrarFirmaAutografa
      };

      // SI LOS VALORES DE LA PETICIÓN ESTÁN CORRECTOS, SE PROCEDE A ENVIAR LA PETICIÓN AL SERVIDOR
      if(this.ValidarValoresDePeticion(peticion) == true){
        
        axios
          .post(
            api.conexion + api.SIAP.funcion.AgregarNuevoPuesto,
            peticion,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal
            )
          )
          .then(response => {
            comun.SeEstaCargandoInformacion(false);
            if (response.data.SiHayError == false) {
              comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
              //this.personasEncontradas = response.data.InfoPersonas;
              //this.LlenarTablaDePersonasEncontradas();
              this.$router.go();
            } else {
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
              this.$router.go();
            }
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.error(e);
          });
        }else{
          comun.SeEstaCargandoInformacion(false);
          comun.mensajeDeAlerta("Verificar campos. Información faltante", null, null);
        }
    },
    LlenarTablaDePersonasEncontradas() {
      // LLENA LA TABLA CON LAS PERSONAS ENCONTRADAS
      var $tabla_Personas = $("#tabla_PersonasParaElegirEstructuraOrganica");
      $tabla_Personas.bootstrapTable({ data: this.personasEncontradas });
      $tabla_Personas.bootstrapTable("load", this.personasEncontradas);
      
    },
    ValidarValoresDePeticion(peticion){
      
      let peticionAprovada = false;
      
      if(peticion.AreaID != null && peticion.AreaID > 0){peticionAprovada = true;}else{peticionAprovada = false; return;}
      if(peticion.DepartamentoID != null && peticion.DepartamentoID >= 0){peticionAprovada = true;}else{peticionAprovada = false; return;}
      
      // SI SE TIENE SELECCIONADO UN PUESTO DEL COMBO DE PUESTOS, ESTE ES EL QUE SE ENVIA EN LA PETICIÓN
      if(peticion.PuestoID != null && peticion.PuestoID > 0){
        // BORRA EL VALOR DEL NOMBRE DEL NUEVO PUESTO PORQUE YA NO SE NECESITA, YA QUE SE TIENE SELECCIONADA UNA OPCIÓN EN EL COMBO
        peticion.NombreDeNuevoPuesto = null;

        peticionAprovada = true;
      }else{
        // SI NO TIENE SELECCIONADO UNA OPCIÓN EN EL COMBO Y TAMPOCO EN EL INPUT DE NUEVO PUESTO, SE DENEGA LA APROVACIÓN DE LA PETICIÓN
        if(peticion.NombreDeNuevoPuesto == "" || peticion.NombreDeNuevoPuesto == null && peticion.PuestoID != -1){
          peticionAprovada = false; 
          return;
        } else{
          peticionAprovada = true;
        }        
      }      
      
      if(peticion.TipoDePuestoId != null && peticion.TipoDePuestoId > 0){peticionAprovada = true;}else{peticionAprovada = false; return;} 
      if(peticion.NivelPuestoId != null && peticion.NivelPuestoId > 0){peticionAprovada = true;}else{peticionAprovada = false; return;} 
      if(peticion.FechaInicialDelPuesto != null && moment.isDate(new Date(peticion.FechaInicialDelPuesto)) ){peticionAprovada = true;}else{peticionAprovada = false; return;} 
      if(peticion.FechaFinalDelPuesto != null && moment.isDate(new Date(peticion.FechaFinalDelPuesto)) ){peticionAprovada = true;}else{peticionAprovada = false; return;} 
      if(peticion.TurnoID != null && peticion.TurnoID > 0){peticionAprovada = true;}else{peticionAprovada = false; return;} 
      if(peticion.Tipo_PlazaID != null && peticion.Tipo_PlazaID > 0){peticionAprovada = true;}else{peticionAprovada = false; return;} 
      if(peticion.EstructuraOrganicaSuperiorId != null && peticion.EstructuraOrganicaSuperiorId > 0){peticionAprovada = true;}else{peticionAprovada = false; return;} 
      
      return peticionAprovada;
    }
  },
  mounted: function() {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/NuevoPuesto.vue